import { lazy } from 'react'

export const DashboardPage = lazy(() => import('./DashboardPage'))
export const SettingsPage = lazy(() => import('./SettingsPage'))
export const AddSectionsPage = lazy(() => import('./AddSectionsPage'))
export const SplitBuilderPage = lazy(() => import('./SplitBuilderPage'))
export const CoachPage = lazy(() => import('./CoachPage'))
